import type { SearchResponse } from '@mrb91002/shared-types';
import { API_BASE } from './config';

export async function searchBlended(
  query: string,
  limit: number = 20,
  offset: number = 0
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    q: query,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  const response = await fetch(`${API_BASE}/search?${params}`)
  
  if (!response.ok) {
    throw new Error('Search failed')
  }
  
  return response.json()
}

export async function searchByTag(
  tag: string,
  limit: number = 20,
  offset: number = 0
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    tag: tag,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  const response = await fetch(`${API_BASE}/search?${params}`)
  
  if (!response.ok) {
    throw new Error('Tag search failed')
  }
  
  return response.json()
}

export async function searchByDifficulty(
  difficulty: string,
  limit: number = 20,
  offset: number = 0
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    difficulty: difficulty,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  const response = await fetch(`${API_BASE}/search?${params}`)
  
  if (!response.ok) {
    throw new Error('Difficulty search failed')
  }
  
  return response.json()
}